import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { adaptMarginLeft } from "@/utils/adapter";
import { FONT_FAMILY } from "@/utils/font-family";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

const useStyle = (isQuoteConfirmation) => {
  const { secondColor, grayColor, theme, primaryColor, successColor } =
    useGomakeTheme();
  const { t } = useTranslation();
  const dir = t("direction");
  const classes = useMemo(() => {
    return {
      mainContainer: {
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "space-between",
        alignItems: "flex-start",
        width: "100%",
        maxWidth: "100%",
        position: "relative" as "relative",
        height: "100%",
        overflow: "visible",
      },
      titleQuateContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 5,
      },
      settingsStatusContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: 5,
      },
      quoteStatusContainer: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // padding: "4px 12px",
        padding: "6px 10px",
        color: primaryColor(500),
        ...FONT_FAMILY.Inter(500, 14),
        borderRadius: 999,
        backgroundColor: primaryColor(100),
      },
      titleSettingContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "space-between",
        alignItems: "center",
        width: "100%",
        // marginBottom: 14,
      },
      quoteNumberStyle: {
        ...FONT_FAMILY.Lexend(500, 24),
        color: secondColor(500),
        lineHeight: "30px",
      },
      dateFiled: {
        display: "flex",
        position: "relative" as "relative",
        ...FONT_FAMILY.Lexend(400, 16),
        color: grayColor(500),
        cursor: "pointer",
        gap: "5px",
      },
      dateValue: {
        color: "black",
      },
      datePickerContainer: {
        display: "flex",
        position: "absolute" as "absolute",
        top: 0,
        right: 100,
        visibility: "hidden" as "hidden",
      },
      datesContainer: {
        display: "flex",
        flexDirection: "row" as "row",
        justifyContent: "flex-start",
        alignItems: "center",
        width: "100%",
        gap: 17,
        borderBottom: `1px solid ${grayColor(200)}`,
      },
      firstBorder: {
        width: "100%",
        borderBottom: `1px solid ${grayColor(200)}`,
      },
      lineDateStyle: {
        width: 1,
        height: 24,
        flexShrink: 0,
        alignSelf: "center" as "center",
        backgroundColor: "#D0D5DD",
        // Parent row gap is 17px. Pull the rule into that gap so the
        // line sits centered without opening a second gap.
        marginLeft: -8,
        marginRight: -8,
        pointerEvents: "none" as "none",
      },
      bordersecondContainer: {
        width: "100%",
        borderBottom: `1px solid ${grayColor(200)}`,
        marginBottom: 12,
        marginTop: 12,
        maxHeight: 140,
        overflow: "auto",
      },
      secondContainer: {
        width: "100%",
        height: "100%",
        overflow: "visible",
        display: "flex",
        flexDirection: "column" as "column",
        padding: isQuoteConfirmation ? "20px 100px 0px 100px" : "none",
        minHeight: 0,
      },
      signatureApproval: {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 8,
        padding: "10px",
        minHeight: 43,
        backgroundColor: primaryColor(500),
        color: "#FFFFFF",
        borderRadius: 8,
        ...FONT_FAMILY.Inter(500, 14),
        lineHeight: "20px",
        cursor: "pointer",
        transition: "background-color 0.2s ease, box-shadow 0.2s ease",
        boxShadow: "0 1px 3px rgba(0,0,0,0.08)",
      },
      titleStyle: {
        display: "flex",
        ...FONT_FAMILY.Lexend(500, 18),
        color: "Black",
        lineHeight: "30px",
        width: "70%",
        flexDirection: "column" as "column",
        alignItems: "flex-start",
        alignSelf: "center",
        justifyContent: "center",
        gap: "16px",
        margin: "10px 0px",
      },
      borderContainer: {
        width: "100%",
        alignSelf: "center",
        borderBottom: `1px solid ${grayColor(200)}`,
        maxHeight: 140,
        overflow: "auto",
        marginTop: "20px",
      },
      budgetList: {
        width: 185,
        height: 36,
        boxShadow: "none", // Shadow style
        borderRadius: 8,
        border:
          "1px solid var(--Component-colors-Components-Buttons-Secondary-button-secondary-border, #D0D5DD)",
        ...FONT_FAMILY.Lexend(500, 14),
        "& input::placeholder": {
          color: "#344054 !important",
          fontFamily: "Inter !important",
          fontWeight: 600,
          fontSize: "14px !important",
        },
      },
      createdByContainer: {
        ...FONT_FAMILY.Lexend(400, 16),
        color: "#667085",
      },
      inputLbl: {
        ...FONT_FAMILY.Lexend(400, 14),
        display: "flex",
        alignItems: "center",
        width: "max-content",
        ...adaptMarginLeft(dir, 8),
      },
      createNewDocument: {
        display: "inline-flex",
        padding: "0px 12px",
        justifyContent: "center",
        alignItems: "center",
        gap: "4px",
        borderRadius: "8px",
        border: `1px solid ${primaryColor(600)}`,
        background: "#FFF",
        boxShadow: "0px 1px 2px 0px rgba(16, 24, 40, 0.05)",
        textTransform: "none" as "none",
        color: primaryColor(600),
        ...FONT_FAMILY.Inter(500, 14),
        lineHeight: "18px",
        height: "30px",
      },
    };
  }, [isQuoteConfirmation, theme, successColor]);
  return {
    classes,
  };
};
export { useStyle };
